import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { SubscriptionPlan } from '@vi-iot/client';

import { BookingPlansLoadingState, BookingStore, noInstallationsError, RemoteConfigStore } from '@store';

import { matTooltipSetter } from '../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-flat-booking-plans',
  templateUrl: './flat-booking-plans.component.html',
  styleUrls: ['./flat-booking-plans.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatBookingPlansComponent implements OnInit {
  BookingPlansLoadingState = BookingPlansLoadingState;
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Output() planSelected = new EventEmitter();
  @Output() trialPlanSelected = new EventEmitter();

  BookingPlans = SubscriptionPlan;
  noInstallationsError = noInstallationsError;

  constructor(public bookingStore: BookingStore, public remoteConfigStore: RemoteConfigStore) {}

  ngOnInit(): void {
    this.bookingStore.fetchSubscriptionsPlans();
    this.bookingStore.getTrialSubscriptions();
    this.bookingStore.getAllVitoguideSubscriptions();
    this.bookingStore.getFlatRatePriceDetails();
  }

  selectPlan(plan: SubscriptionPlan): void {
    this.bookingStore.selectPlan(plan);
    if (plan === SubscriptionPlan.Pro) {
      this.planSelected.emit();
    }
    if (plan === SubscriptionPlan.Trial) {
      this.trialPlanSelected.emit();
    }
  }
}
